import React from 'react';
import {observer} from 'mobx-react';
import {AvatarList} from 'shared/components';

const ManagerAvatars = observer(({model: reviewee}) => {
  return (
    <AvatarList limit={4} moreModalEnabled employees={reviewee.reviewManagerEmployees}/>
  );
});

export default ManagerAvatars;
